import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import PageStyledTitle from '../PageStyledTitle';
import useIntersection from '../useIntersection';
import { Container } from '../../styles/variables';
import {
  backEnd, frontEnd, platform, professional, toolsMethods,
} from '../../config';

// Add some animations to the app
// Let's think about it
const Intro = styled.div`
  font-family: Montserata, sans-serif;
  font-weight: 200;
  font-size: 1rem;
  padding-top: 3rem;
  display: block;

  .about-title {
    margin-top: 20px;
  }

  .intro-right {
    padding: 0 15px;
    margin-top: 4rem;
  }

  .intro-left {
    padding: 0 15px;
  }

  .intro-left p {
    font-weight: 400;
    font-size: 1.1rem;
    color: rgb(231, 240, 249);
  }

  .intro-left a {
    color: #35a16d;
    transition: 300ms linear 0s;

    :hover {
      color: #54f8a5;
    }
  }

  .stack-title {
    margin-top: 0;
    display: flex;
    align-items: center;
    color: rgba(240, 248, 255, 0.96);
  }

  .stack-list-ctn {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }

  .stack-text {
    font-family: Montserata, sans-serif;
    display: block;
    font-weight: 400;
    font-size: 0.8rem;
    margin-right: 1rem;
    margin-top: 0;
    transition: 300ms linear 0s;
    color: rgba(240, 248, 255, 0.96);

    ::before {
      content: '▹';
      color: #35a16d;
      margin-right: 0.5rem;
    }

    :hover {
      ::before {
        transition: 300ms linear 0s;
        color: #ed25ae;
        margin-right: 0.3rem;
        margin-left: 0.2rem;
      }
    }
  }

  @media (min-width: 768px) {
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 5rem;

    .intro-right {
      margin-top: 0;
    }
  }
`;

const p1 = (
  <p>
    Hi, my name is Lionel, I&#39;m a full-stack developer. Over the past few years, I
    had the opportunity to develop solutions for several companies, start-ups,
    and small businesses. During these years, I made applications for the
    web and smartphones. These years helped me to acquire experience and
    a certain ability to adapt and learn faster.
  </p>
);

const p2 = (
  <p>
    I studied at
    {' '}
    <a href="https://www.microverse.org/">Microverse</a>
    {' '}
    , an online program which allowed me to acquire professional
    skills in web development, and collaborative and remote work. Now I work
    remotely with companies from all over the world. I am currently
    specializing in web development to build amazing software solutions for you.
  </p>
);

const stack = [platform, frontEnd, backEnd, toolsMethods, professional];

const introParagraphs = [
  {
    id: 0,
    p: p1,
  },
  {
    id: 1,
    p: p2,
  },
];

function About() {
  const ref = useRef(null);
  const inViewPort = useIntersection(ref, '0px');

  useEffect(() => {
    if (inViewPort) {
      // console.log('About is in viewport', inViewPort);
    } else {
      // console.log('About is not in viewport', inViewPort);
    }
  }, [inViewPort]);

  return (
    <Container id="about">
      <div ref={ref}>
        <PageStyledTitle title="About" mClassName="about-title" />
      </div>
      <Intro>
        <div className="intro-left">
          {introParagraphs.map((item) => (
            <div key={item.id}>{item.p}</div>
          ))}
        </div>
        <div className="intro-right">
          {stack.map((element) => (
            <div key={element.id}>
              <h4 className="stack-title">{element.name}</h4>
              <div className="stack-list-ctn">
                {element.value.map((tech) => (
                  <h5 key={tech.toString()} className="stack-text">{tech}</h5>
                ))}
              </div>
            </div>
          ))}
        </div>
      </Intro>
    </Container>
  );
}

export default About;
